// @flow
import React, { Component } from 'react';
import { type Element as ReactElement } from 'react';
import { CustomModelListTable } from './CrudTableStyles.js';
import { type Currencies } from '../../utilities/types';
import Paginator from '../../components/Paginator';
import TableBody from './components/TableBody';
import CustomPerPageFilter from './components/CustomPerPageFilter';
import { ModelListDiv } from '../../components/ModelListStyles.js';

type Props = {
  TableHeader: ReactElement<any>,
  TableRow: ReactElement<any>,
  failedLoad: boolean,
  loading: boolean,
  currencies?: Currencies,

  //Paginator
  paginatorTotal?: number,
  currentPage?: number,
  changePage?: ({
    id: number | string,
    page: number,
    perPage: number
  }) => void,
  previouslyVisited?: number[],

  //PerPage Filter
  currentPerPage?: string,
  setPerPage?: () => void,
  perPageOptions?: Array<number>,

  loadTableIndexData: ({ page: number }) => void,
  // tableData: Array<{ currency: string, status: string, id: number }>,
  tableData: Array<any>,
  tableBodyOptions: {
    text: string,
    model: string,
    img: string
  }
};

export default class CrudTableIndex extends Component<Props> {
  componentDidMount() {
    this.props.loadTableIndexData({
      page: this.props.currentPage || NaN
      // perPage: 25
    });
  }

  render() {
    const hasPerPageFilter =
      Boolean(!this.props.loading) &&
      Boolean(this.props.perPageOptions) &&
      this.props.tableData.length > 0;

    const hasPaginator =
      Boolean(!this.props.loading) &&
      Boolean(this.props.paginatorTotal) &&
      this.props.tableData.length > 0;

    return (
      <ModelListDiv>
        <CustomModelListTable hasPerPageFilter={hasPerPageFilter}>
          <thead>{this.props.TableHeader}</thead>
          <tbody>
            <TableBody
              failedLoad={this.props.failedLoad}
              loading={this.props.loading}
              // tableData={[]}
              tableData={this.props.tableData}
              currencies={this.props.currencies}
              TableRow={this.props.TableRow}
              tableBodyOptions={this.props.tableBodyOptions}
            />
          </tbody>
        </CustomModelListTable>
        {hasPerPageFilter && (
          <CustomPerPageFilter
            currentPerPage={this.props.currentPerPage || ''}
            // $FlowFixMe
            setPerPage={this.props.setPerPage}
            perPageOptions={this.props.perPageOptions || []}
          />
        )}
        {hasPaginator && (
          <Paginator
            paginatorTotal={this.props.paginatorTotal || NaN}
            currentPage={this.props.currentPage || NaN}
            // $FlowFixMe
            changePage={this.props.changePage}
            previouslyVisited={this.props.previouslyVisited || []}
          />
        )}
      </ModelListDiv>
    );
  }
}
